import React, { Component } from 'react';
import { Link } from 'react-router';
import { Form, Input, Modal, Table } from 'antd';
import { queryIncCustomPayableToBeTurns } from '@api/incubator/custom';

class ModalCarry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTips: false,
      data: {
        list: [],
        pagination: {},
      },
      selectedRowKeys: props.data ? [props.data.uuid] : [],
    };
  }

  componentDidMount() {
    this.oldPayableUuid = this.props.data ? this.props.data.uuid : '';
    this.oldBusinessUuid = this.props.data ? this.props.data.businessUuid : '';
    this.payableNo = this.props.data ? this.props.data.no : '';
    this.getIncCustomPayableToBeTurns();
  }

  /**
   * 同一公司下的待结转列表
   */
  getIncCustomPayableToBeTurns = current => {
    this.setState({ loading: true });
    const { customUuid, incubatorUuid, type, renewBusinessUuids } = this.props;
    let str = '';
    if (renewBusinessUuids.length > 0) {
      renewBusinessUuids.map(item => {
        str += `${item},`;
        return item;
      });
      str = str.substring(0, str.length - 1);
    }
    let params = {
      customUuid,
      incubatorUuid,
      renewBusinessUuids: str,
      limit: 5,
      start: current || 1,
    };

    if (type === 0) {
      params = { ...params, type };
    }
    queryIncCustomPayableToBeTurns(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: {
            list: res.data,
            pagination: {
              pageSize: 5,
              total: res.totalSize,
              current: current || 1,
            },
          },
        });
      }
      this.setState({ loading: false });
    });
  };

  onTableChange = pagination => {
    this.getIncCustomPayableToBeTurns(pagination.current);
  };

  handleChange = (e, option) => {};

  handleSubmit = e => {
    e.preventDefault();
    if (!this.oldBusinessUuid) {
      this.setState({
        showTips: true,
      });
    } else {
      this.setState({
        showTips: false,
      });
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleTurn({
          oldBusinessUuid: this.oldBusinessUuid,
          oldPayableUuid: this.oldPayableUuid,
          payableNo: this.payableNo,
          price: values.price,
        });
      }
    });
  };

  columns = () => {
    return [
      {
        title: '账单编号',
        dataIndex: 'no',
        width: 150,
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.businessUuid}/info`}>{text}</Link>
        ),
      },
      {
        title: '账单类型',
        dataIndex: 'type',
        render: text => `${{ 0: '押金', 1: '工位费用', 2: '地址费用' }[text]}`,
      },
      {
        title: '入驻孵化器',
        dataIndex: 'incubator',
        width: 200,
      },
      {
        title: '可转结金额',
        dataIndex: 'price',
        width: 120,
      },
    ];
  };

  onSelect = (record, selected) => {
    this.oldPayableUuid = record.uuid;
    this.oldBusinessUuid = record.businessUuid;
    this.payableNo = record.no;
    if (this.state.showTips) {
      this.setState({
        showTips: false,
      });
    }
  };

  onChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      loading,
      showTips,
      selectedRowKeys,
      data: { list, pagination },
    } = this.state;
    const { data } = this.props;
    const rowSelection = {
      type: 'radio',
      selectedRowKeys,
      onChange: this.onChange,
      onSelect: this.onSelect,
    };
    getFieldDecorator('oldBusinessUuid');
    return (
      <Modal
        visible
        width={700}
        title="结转列表"
        onOk={this.handleSubmit}
        onCancel={this.props.onCancel}
      >
        <Table
          rowKey="uuid"
          loading={loading}
          dataSource={list}
          columns={this.columns()}
          pagination={pagination}
          rowSelection={rowSelection}
          onChange={this.onTableChange}
        />
        {showTips ? <span style={{ color: 'red' }}>请选择一条记录进行结转！</span> : null}
        <Form.Item label="转结押金">
          {getFieldDecorator('price', {
            rules: [{ required: true, message: '请填写结转押金!' }],
            initialValue: data ? data.price : '',
          })(<Input />)}
        </Form.Item>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(ModalCarry);



// WEBPACK FOOTER //
// ./src/components/incubator/bill/detail/ModalCarry.js